import React, { useState } from "react";
import { Accordion, Form, InputGroup } from "react-bootstrap";
import "./FAQ.css";

function FAQ() {
    const [searchTerm, setSearchTerm] = useState("");

    // Updated FAQ Data from Image
    const faqs = [
        {
            question: "What is My MDS?",
            answer:
                "My MDS is a white-label eLearning platform designed for driving schools, educational institutes, transport companies, and fleet firms to provide branded, self-paced driver training. It includes interactive courses, assessments, dashboards, and certification — available on both Android and iOS.",
        },
        {
            question: "Is My MDS available as a white-label solution?",
            answer:
                "Yes, My MDS is fully white-labelled, allowing organizations to launch the platform under their own name, logo, branding, and identity. Learners will see the app as your institution’s official learning platform.",
        },
        {
            question: "Does My MDS support assessments and certification?",
            answer:
                "Absolutely. My MDS includes interactive quizzes, practice question banks, mock tests, auto-scoring, and auto-generated completion certificates.",
        },
        {
            question: "Can multiple branches or locations use the same system?",
            answer:
                "Yes. My MDS is built for multi-location deployment, enabling organizations to manage multiple branches, batches, and learner groups from a centralized dashboard.",
        },
        {
            question: "What are the technical requirements for learners?",
            answer:
                "Learners only need: a smartphone (Android or iOS), basic internet connectivity, and access credentials provided by the institution.",
        },
    ];

    // Filter Function
    const filteredFaqs = faqs.filter((faq) =>
        faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
        faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <section className="FAQ section_margin">
            <div className="container">
                {/* Header */}
                <div className="faq-header">
                    <h2>
                        I have <span>A QUESTION?</span>
                    </h2>
                    <div className="faq-search">
                        <InputGroup>
                            <Form.Control
                                type="text"
                                placeholder="Ask anything about My MDS..."
                                aria-label="Search FAQ"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </InputGroup>
                    </div>
                </div>

                {/* FAQ Accordion */}
                <Accordion defaultActiveKey="0" flush className="faq-accordion">
                    {filteredFaqs.length > 0 ? (
                        filteredFaqs.map((faq, index) => (
                            <Accordion.Item eventKey={String(index)} key={index}>
                                <Accordion.Header>
                                    Q{index + 1}: {faq.question}
                                </Accordion.Header>
                                <Accordion.Body>{faq.answer}</Accordion.Body>
                            </Accordion.Item>
                        ))
                    ) : (
                        <p className="text-center mt-3">No matching questions found.</p>
                    )}
                </Accordion>
            </div>
        </section>
    );
}

export default FAQ;
